import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _AbstractAccount, _LoginServices, _single } from "../../core/services/dataBean/EntityCatalog";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "../../core/components/Spinner";
import { encryptData } from "../../utils/helpers";
import "./Portal.css";
import "./LoginPortal.css";
import { configPortal } from "../../configPortal";
import { ValidationOtp } from "../../modules/theme/Component/ValidationOTP/ValidationOtp";
import { Modal } from "../../modules/theme/Component/Modal";

interface Props {
    setIsLogged: any;
}


export const LoginPortal = ({ setIsLogged }: Props) => {
    const logo = configPortal.IMG_SOURCE ?? _single.getIMGLogo();
    const validation = configPortal.OTP_LOGIN_VAL ?? false;
    const footerInfo = configPortal.FOOTER_INFO ?? "Trv, Tv. 69b Bis #73a-40, Bogotá, Cundinamarca";
    const imgLogin = configPortal.IMG_LOGIN ?? "";
    const portalMenus: number = configPortal.MENUS_PORTAL ?? 1;
    const nameApp = configPortal.NAME_APP ?? "Portal";
    const loreApp = configPortal.DESCRIPTION_APP ?? "...";

    const { instance, bean, setBean } = useDataBean(_LoginServices);
    const acc = useDataBean(_AbstractAccount);
    const navigate = useNavigate();
    const [idNit, setNIT] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [onOtpValidated, setOnOtpValidated] = useState<() => void>(() => () => { });
    const [passwordValid, setPasswordValid] = useState<any>({
        password: "",
        password2: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const [modal, setModal] = useState<any>({ name: "Formulario de Registro", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalForget, setModalForget] = useState<any>({ name: "Validacion de Cuenta", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalUpdatePass, setModalUpdatePass] = useState<any>({ name: "Actualizar contraseña de Usuario", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });

    const otpValidator = useRef<any>(null);

    useEffect(() => {
        const primaryColor = configPortal.PRIMARY_COLOR_APP || '#ca4e07';
        document.documentElement.style.setProperty('--primary-color', primaryColor);
    }, []);

    const validatePassword = () => {
        instance.validateWorkSession('user/password', encryptData(idNit + ""), encryptData(password + ""), null, null, null).then((res: any) => {
            console.log(res)
            const acc = res.Account.DataBeanProperties.IDAccount;
            if (acc) {
                _single.startSesion(res.Account.DataBeanProperties);
                if (validation) {
                    if (otpValidator.current) {
                        setOnOtpValidated(() => () => {
                            sessionStorage.setItem("token", JSON.stringify(true));
                            setIsLogged(true);
                            if (portalMenus == 1) {
                                navigate("/portal/home/personal-info");
                            } else {
                                navigate("/portal/home/personal-account-info");
                            }
                            toast.success('Registrado con éxito');
                        });
                        otpValidator.current.openOTPModal("Validacion de Identidad");
                    }
                } else {
                    sessionStorage.setItem("token", JSON.stringify(true));
                    setIsLogged(true);
                    if (portalMenus == 1) {
                        navigate("/portal/home/personal-info");
                    } else {
                        navigate("/portal/home/personal-account-info");
                    }
                    toast.success('Registrado con éxito');
                }
            } else {
                toast.error("No se pudo validar la identidad de la cuenta.");
                setPassword("");
            }
        }).catch(err => {
            toast.error('No se pudo validar la contraseña correctamente, vuelva a intentarlo.');
        });
    };



    const registerAffiliate = () => {
        instance.registerAffiliate(encryptData(JSON.stringify(bean))).then(
            (resp) => {
                console.log(resp);
                console.log(encryptData(JSON.stringify(bean)));
                setModal({ ...modal, view: false });
                toast.success(resp.MSG);
            }
        ).catch(error => {
            console.error('Error al registrar afiliado', error);
            toast.error('No se pudo registrar el afiliado correctamente, vuelva a intentarlo.');
        })
    }

    const validateUserExists = async (): Promise<boolean> => {
        const props = { ID: parseInt(bean.Identification) };
        console.log(props)
        try {
            const res = await instance.validateCreditAffiliate(encryptData(JSON.stringify(props)));
            toast.info(res.MSG);
            _single.startSesion({
                IDAccount: res.ID,
                Nit: bean.Identification
            });
            acc.setBean({
                IDAccount: res.ID,
                Nit: bean.Identification
            })
            return res.ID ? true : false;
        } catch (err) {
            toast.error("No se pudo validar la cuenta, vuelva a intentarlo.");
        }
    };

    const handleModalForgetSubmit = async () => {
        console.log(await validateUserExists());
        const exists = await validateUserExists();
        if (flowSource === "forgot") {
            console.log(flowSource)
            if (exists) {
                setModalForget({ ...modalForget, view: false });
                setModalUpdatePass({ ...modalUpdatePass, view: true });
                setBean({});
            } else {

            }
        }

        if (flowSource === "register") {
            if (!exists) {
                setModalForget({ ...modalForget, view: false });
                setModal({ ...modal, view: true });
                setBean(prev => ({ Identification: prev.Identification }));
            } else {

            }
        }
        setFlowSource(null);
    };


    const [passwordValidation, setPasswordValidation] = useState({
        minLength: false,
        upperCase: false,
        lowerCase: false,
        number: false,
        specialChar: false,
        passwordsMatch: false,
        allValid: false
    });

    useEffect(() => {
        const validations = {
            minLength: passwordValid.password.length >= 8,
            upperCase: /[A-Z]/.test(passwordValid.password),
            lowerCase: /[a-z]/.test(passwordValid.password),
            number: /[0-9]/.test(passwordValid.password),
            specialChar: /[^A-Za-z0-9]/.test(passwordValid.password),
            passwordsMatch: passwordValid.password === passwordValid.password2
        };

        setPasswordValidation({
            ...validations,
            allValid: Object.values(validations).every(v => v === true)
        });
    }, [passwordValid]);

    const updatePassword = () => {
        if (!passwordValidation.allValid) {
            toast.error("La contraseña no cumple con los requisitos")
        } else {
            acc.instance.activateUserAccountLocal(acc.bean.IDAccount, encryptData(acc.bean.Nit), encryptData(passwordValid.password)).then(
                (resp) => {
                    console.log(acc.bean)
                    toast.success("Contraseña actualizada correctamente")
                    setModalUpdatePass({ ...modalUpdatePass, "view": false })
                    setPasswordValid({ ...passwordValid, password: "", password2: "" });
                }
            ).catch(
                (err) => {
                    toast.error("Error al actualizar la contraseña")
                }
            )
        }
    }

    const [flowSource, setFlowSource] = useState<"register" | "forgot" | null>(null);

    useEffect(() => {
        if (flowSource) {
            setModalForget({ ...modalForget, view: true });
        }
    }, [flowSource])

    useEffect(() => {
        if (modalForget.view === false) {
            setFlowSource(null)
        }
    }, [modalForget.view])

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            registerAffiliate()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Tel", "EMail", "Surname1", "Name1", "Identification"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const handleTextInput = (text: string) => {
        return text.replace(/[^a-zA-ZÁÉÍÓÚáéíóúÑñ]/g, '');
    };


    return (
        <>
            <Spinner />
            <div className="container-fluid d-flex flex-column min-vh-100 p-0">
                <header className="portal-header">
                    <img
                        src="./assets/images/core/govco.png"
                        alt="gov.co"
                        style={{ maxHeight: "60px", height: "auto", width: "auto", objectFit: "contain" }}
                    />
                </header>

                <div className="d-flex flex-column flex-md-row flex-grow-1" style={{
                    backgroundImage: imgLogin
                        ? `url('./assets/images/customizables/${imgLogin}')`
                        : "linear-gradient(-45deg, #036 50%, #069)",
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}>

                    <div className="d-flex flex-column flex-md-row flex-grow-1 portal-body">
                        <div className="login-left d-none d-md-flex flex-column justify-content-center align-items-center text-center p-5">
                            <div className="login-card">
                                <h2 className="fw-bold">{nameApp}</h2>
                                <p className="mt-3">{loreApp}</p>
                            </div>
                        </div>

                        <div className="login-container">
                            <div className="login-card login-right bg-white shadow p-4">
                                <img
                                    src={`./assets/images/customizables/${logo ?? "logo-amc-negro.png"}`}
                                    alt="Logo Banco"
                                    className="mb-4 logo-img"
                                />
                                <h3 className="fw-bold mb-3">Inicia sesión</h3>
                                {/* <p>Completa los siguientes datos:</p>    */}

                                <form>
                                    <div className="form-group">
                                        <label htmlFor="username">Identificación</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            placeholder="Ingrese su Usuario"
                                            value={idNit}
                                            onChange={(e) => setNIT(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label htmlFor="password">Contraseña</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            placeholder="Ingrese su contraseña"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary-custom mt-4"
                                        onClick={validatePassword}
                                    >
                                        Ingresar
                                    </button>
                                </form>

                                <div className="d-flex justify-content-between mt-3">
                                    <a className="text-decoration-none pointer" onClick={() => setFlowSource("forgot")}>
                                        ¿Olvidaste tu usuario/contraseña?
                                    </a>
                                    <a className="text-decoration-none pointer" onClick={() => setFlowSource("register")}>
                                        Quiero Registrarme
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

                <footer className="w-100 d-flex align-items-center justify-content-center text-center mt-auto" style={{ maxHeight: "50px", backgroundColor: "#025dc3", height: "50px" }}>
                    <p style={{ color: "white", fontSize: "0.9rem", margin: 0 }}>
                        {footerInfo}
                    </p>
                </footer>

            </div>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }} onSubmitLabel="Registrarse" >
                <div className="row">
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('Identification') ? 'has-error' : ''}`}>NIT/CC</label>
                        <input type="number" className="form-control" placeholder="NIT o CC" value={bean.Identification} onChange={(e) => { setBean({ ...bean, Identification: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('Name1') ? 'has-error' : ''}`}>Primer Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            title="Solo se permiten letras sin espacios ni caracteres especiales"
                            placeholder="Nombre"
                            value={bean.Name1}
                            onChange={(e) =>
                                setBean({ ...bean, Name1: handleTextInput(e.target.value) })
                            }
                        />
                    </div>
                    <div className="col-md-12">
                        <label>Segundo Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            title="Solo se permiten letras sin espacios ni caracteres especiales"
                            placeholder="Nombre"
                            value={bean.Name2}
                            onChange={(e) =>
                                setBean({ ...bean, Name2: handleTextInput(e.target.value) })
                            }
                        />
                    </div>
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('Surname1') ? 'has-error' : ''}`}>Primer Apellido</label>
                        <input
                            type="text"
                            className="form-control"
                            title="Solo se permiten letras sin espacios ni caracteres especiales"
                            placeholder="Nombre"
                            value={bean.Surname1}
                            onChange={(e) =>
                                setBean({ ...bean, Surname1: handleTextInput(e.target.value) })
                            }
                        />
                    </div>
                    <div className="col-md-12">
                        <label>Segundo Apellido</label>
                        <input
                            type="text"
                            className="form-control"
                            title="Solo se permiten letras sin espacios ni caracteres especiales"
                            placeholder="Nombre"
                            value={bean.Surname2}
                            onChange={(e) =>
                                setBean({ ...bean, Surname2: handleTextInput(e.target.value) })
                            }
                        />
                    </div>
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('EMail') ? 'has-error' : ''}`}>Correo Electronico</label>
                        <input type="email" className="form-control" placeholder="Email" value={bean.EMail} onChange={(e) => { setBean({ ...bean, EMail: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('Tel') ? 'has-error' : ''}`}>Telefono/Celular</label>
                        <input type="tel" className="form-control" placeholder="Telefono/Celular" value={bean.Tel} onChange={(e) => { setBean({ ...bean, Tel: e.target.value }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalForget} updateModal={setModalForget} eventModal={handleModalForgetSubmit} onSubmitLabel="Consultar">
                <div className="row">
                    <div className="col-md-12">
                        <label>Identificación</label>
                        <input
                            type="number"
                            className="form-control"
                            value={bean.Identification}
                            onChange={(e) => {
                                setBean({ ...bean, Identification: e.target.value });
                            }}
                        />
                    </div>
                </div>
            </Modal>


            <Modal modal={modalUpdatePass} updateModal={setModalUpdatePass} onSubmitLabel="Confirmar" eventModal={() => {
                if (!passwordValid.password) {
                    toast.error("La contraseña debe tener caracteres")
                } else {
                    if (otpValidator.current) {
                        setOnOtpValidated(() => () => {
                            updatePassword()
                        });
                        otpValidator.current.openOTPModal("Validacion de Identidad");
                    }
                }
            }} >
                <div className="row">
                    <form>

                        <div className="col-md-12 ">
                            <label>Nueva Contraseña</label>
                            <div className="input-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Ingrese su nueva contraseña"
                                    value={passwordValid.password}
                                    onChange={(e) => setPasswordValid({ ...passwordValid, password: e.target.value })}
                                    onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                                    onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                                    onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => setShowPassword(!showPassword)}
                                    onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                                    onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                                    onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
                                >
                                    {showPassword ? "Ocultar" : "Ver"}
                                </button>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <label>Confirmar Contraseña</label>
                            <div className="input-group">
                                <input
                                    type={showPassword2 ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Confirme su nueva contraseña"
                                    value={passwordValid.password2}
                                    onChange={(e) => setPasswordValid({ ...passwordValid, password2: e.target.value })}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => setShowPassword2(!showPassword2)}
                                >
                                    {showPassword2 ? "Ocultar" : "Ver"}
                                </button>
                            </div>
                        </div>
                    </form>

                    <div className="mt-3 text-start">
                        {/* <p><strong>Requisitos de Contraseña:</strong></p> */}
                        <ul className="list-unstyled small">
                            <li style={{ color: passwordValidation.minLength ? "green" : "red" }}>
                                {passwordValidation.minLength ? "✔️" : "❌"} Mínimo 8 caracteres
                            </li>
                            <li style={{ color: passwordValidation.upperCase ? "green" : "red" }}>
                                {passwordValidation.upperCase ? "✔️" : "❌"} Al menos una letra mayúscula
                            </li>
                            <li style={{ color: passwordValidation.lowerCase ? "green" : "red" }}>
                                {passwordValidation.lowerCase ? "✔️" : "❌"} Al menos una letra minúscula
                            </li>
                            <li style={{ color: passwordValidation.number ? "green" : "red" }}>
                                {passwordValidation.number ? "✔️" : "❌"} Al menos un número
                            </li>
                            <li style={{ color: passwordValidation.specialChar ? "green" : "red" }}>
                                {passwordValidation.specialChar ? "✔️" : "❌"} Al menos un carácter especial
                            </li>
                            <li style={{ color: passwordValidation.passwordsMatch ? "green" : "red" }}>
                                {passwordValidation.passwordsMatch ? "✔️" : "❌"} Las contraseñas coinciden
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal>

            <ValidationOtp onValidate={onOtpValidated} ref={otpValidator} />

        </>
    );


};
